import { useEffect, useState } from 'react';

import moment from 'moment';

export const useWorkingHours = (practice) => {
  const [hours, setHours] = useState([]);

  useEffect(() => {
    if (!practice) return;

    const locale = 'en';
    const newHours = [];

    moment.locale(locale);

    const startHr = practice?.working_hours?.startsAt?.hour || 0;
    const endHr = practice?.working_hours?.endsAt?.hour || 24;

    for (let hour = startHr; hour < endHr; hour++) {
      const hourTimeA = moment({ hour }).format('h:mm A');
      const hourTime = moment({ hour }).format('HH:mm');

      newHours.push({
        value: hourTime,
        label: hourTimeA
      });

      for (let minutes = 1; minutes < 12; minutes++) {
        const timeA = moment({
          hour,
          minute: minutes * 5
        }).format('h:mm A');
        const time = moment({
          hour,
          minute: minutes * 5
        }).format('HH:mm');

        newHours.push({
          value: time,
          label: timeA
        });
      }
    }
    setHours(newHours);
  }, [practice]);

  return hours;
};
